module.exports = __webpack_public_path__ + "img/prizes-pl.a82358f7.png";